import React, { useState, useEffect } from "react";
import bootstrap from "bootstrap/dist/js/bootstrap";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { api } from "../../../utils/Api";
import { omit } from "lodash";
import { useParams } from "react-router-dom";

const animatedComponents = makeAnimated();

const initial_value = {
  name: "",
  email: "",
  mobile: "",
  whatsapp: "",
  address: "",
  gstin: "",
  igst: false,
};

let myModal = {};

export default function ModelAddCompany(props: any) {
  const [close_data, SetCloseData] = useState({
    action: "close",
  });
  const [save_data, SetSaveData] = useState(initial_value);
  const [id_value, SerIdValue] = useState(useParams());
  const [service_data, SetServiceData] = useState({});
  const [service_value, SetService] = useState([1, 2, 3, 4, 5, 6]);
  const [save_error, SetSaveError] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    console.log("ModelAddCompany On mount :", props);
    let myModal1 = document.getElementById("AddCompanyModal");
    myModal1.addEventListener("hidden.bs.modal", function (event) {
      console.log("event :", event);
      props.close(close_data);
    });
  }, []);

  useEffect(() => {
    if (props.open) {
      console.log("ModelAddCompany On mount :", props);

      myModal = new bootstrap.Modal(
        document.getElementById("AddCompanyModal"),
        {}
      );
      get_init();
      myModal.show();
    }
  }, [props.open]);

  async function get_init() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
        outlet: id_value.outlet_id,
      },
    };
    let response = await api("/outlet/create_company_init", pass_data);
    console.log("create_company_init response :", response);
    if (response.status_code == 200) {
      if (response.response.hasOwnProperty("services")) {
        Object.keys(response.response.services).map((key, index) => {
          response.response.services[key].map((ele, ele_index) => {
            ele.checked = false;
            ele.old_price_value = ele.price;
          });
        });
        console.log("response.response.services :", response.response.services);
        SetServiceData(response.response.services);
      }
    }
  }

  async function save(event: any) {
    if (
      save_data.name != ""
      // save_data.gstin != "" &&
      // save_data.mobile != "" &&
      // save_data.whatsapp != ""
    ) {
      if (event) event.preventDefault();

      if (
        Object.keys(errors).length === 0 &&
        Object.keys(save_data).length !== 0
      ) {
        console.log("Save Event :", save_data);
        // let checked_service = [];
        // Object.keys(service_data).map((key, index) => {
        //   service_data[key].map((ele, ele_index) => {
        //     if (ele.checked && ele.old_price_value != ele.price) {
        //       checked_service.push({
        //         id: ele.id,
        //         price: ele.price,
        //       });
        //     }
        //   });
        // });
        // save_data.services = checked_service;
        let pass_data = {
          get: {
            brand: id_value.brand_id,
            outlet: id_value.outlet_id,
          },
          post: save_data,
        };
        console.log("pass_data :", pass_data);
        let response = await api("/outlet/create_company", pass_data);
        console.log("company post response :", response);
        if (response.status_code == 201) {
          let item = close_data;
          item.action = "save";
          item.value = response.response.company[0];
          console.log("Close data : ", item);
          SetCloseData(item);
          SetSaveData(initial_value);
          myModal.hide();
        }
      } else {
        alert("There is an Error!");
      }
    } else {
      SetSaveError(true);
    }
  }

  function set(name: any, value: any, event: any) {
    event.persist();

    validate(name, value);

    SetSaveData((oldValues) => ({ ...oldValues, [name]: value }));
  }

  const validate = (name: any, value: any) => {
    //A function to validate each input values
    switch (name) {
      case "name":
        if (value.length <= 2) {
          setErrors({
            ...errors,
            name: "Companyname atleast have 3 letters",
          });
        } else {
          let newObj = omit(errors, "name");
          setErrors(newObj);
        }
        break;

      // case "email":
      //   if (
      //     !new RegExp(
      //       /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      //     ).test(value)
      //   ) {
      //     setErrors({
      //       ...errors,
      //       email: "Enter a valid email address",
      //     });
      //   } else {
      //     let newObj = omit(errors, "email");
      //     setErrors(newObj);
      //   }
      //   break;

      // case "mobile":
      //   if (!new RegExp(/^((\\+91-?)|0)?[0-9]{10}$/).test(value)) {
      //     setErrors({
      //       ...errors,
      //       mobile: "mobile should contains 10 numbers",
      //     });
      //   } else {
      //     let newObj = omit(errors, "mobile");
      //     setErrors(newObj);
      //   }
      //   break;

      // case "whatsapp":
      //   if (!new RegExp(/^((\\+91-?)|0)?[0-9]{10}$/).test(value)) {
      //     setErrors({
      //       ...errors,
      //       whatsapp: "whatsapp should contains 10 numbers",
      //     });
      //   } else {
      //     let newObj = omit(errors, "whatsapp");
      //     setErrors(newObj);
      //   }
      //   break;

      // case "address":
      //   if (value.length <= 0) {
      //     setErrors({
      //       ...errors,
      //       address: "Address not vaild",
      //     });
      //   } else {
      //     let newObj = omit(errors, "address");
      //     setErrors(newObj);
      //   }
      //   break;

      // case "gstin":
      //   if (
      //     !new RegExp(
      //       /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
      //     )
      //   ) {
      //     setErrors({
      //       ...errors,
      //       gstin: "gstin not vaild",
      //     });
      //   } else {
      //     let newObj = omit(errors, "gstin");
      //     setErrors(newObj);
      //   }
      //   break;

      default:
        break;
    }
  };

  function service_on_check(ele: any, ele_index: any, key: any) {
    SetServiceData((prevValue) => {
      prevValue[key][ele_index].checked = !prevValue[key][ele_index].checked;
      if (prevValue[key][ele_index].checked) {
        console.log("On Check");
      } else {
        console.log("On UnCheck");
        prevValue[key][ele_index].price =
          prevValue[key][ele_index].old_price_value;
      }
      return { ...prevValue };
    });
  }

  function service_price_on_change(
    ele: any,
    ele_index: any,
    key: any,
    value: any
  ) {
    SetServiceData((prevValue) => {
      prevValue[key][ele_index].price = value;
      return { ...prevValue };
    });
  }

  return (
    <div
      className="modal fade"
      id="AddCompanyModal"
      tabIndex={-1}
      aria-labelledby="ModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="  modal-title" id="ModalLabel">
              Add Customer
            </h5>
            <button
              type="button"
              className="btn btn-close"
              // data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                SetSaveData(initial_value);
                myModal.hide();
              }}
            ></button>
          </div>
          <div className="modal-body">
            <p>
              <small>Please fill a correct details</small>
            </p>
            <div className="mt-3">
              <form className="row g-3">
                <div className="col-12">
                  <label className="form-label">Customer name</label>
                  <input
                    type="text"
                    className="form-control"
                    minLength={5}
                    required
                    value={save_data.name}
                    onChange={(e) => {
                      set("name", e.target.value, e);
                      SetSaveError(false);
                    }}
                  />
                  {save_error == true ? (
                    <small className="text-red">* Required fields</small>
                  ) : null}
                  {errors.name && (
                    <small className="text-red">{errors.name}</small>
                  )}
                </div>

                <div className="col-md-6 col-12">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={save_data.email}
                    required
                    onChange={(e) => {
                      set("email", e.target.value, e);
                    }}
                  />
                  {/* {errors.email && (
                    <small className="text-red">{errors.email}</small>
                  )} */}
                </div>

                <div className="col-md-6 col-12">
                  <label className="form-label">Mobile Number</label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="fas fa-phone-alt"></i>
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      value={save_data.mobile}
                      required
                      onChange={(e) => {
                        set("mobile", e.target.value, e);
                        SetSaveError(false);
                      }}
                    />
                  </div>
                  {/* {save_error == true ? (
                    <small className="text-red">* Required fields</small>
                  ) : null}
                  {errors.mobile && (
                    <small className="text-red">{errors.mobile}</small>
                  )} */}
                </div>

                <div className="col-md-6 col-12">
                  <label className="form-label">Whatsapp Number</label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="fab fa-whatsapp"></i>
                    </span>
                    <input
                      type="number"
                      className="form-control"
                      value={save_data.whatsapp}
                      required
                      onChange={(e) => {
                        set("whatsapp", e.target.value, e);
                        SetSaveError(false);
                      }}
                    />
                  </div>
                  {/* {save_error == true ? (
                    <small className="text-red">* Required fields</small>
                  ) : null}
                  {errors.whatsapp && (
                    <small className="text-red">{errors.whatsapp}</small>
                  )} */}
                </div>

                <div className="col-md-4 col-8">
                  <label className="form-label">GST Number</label>
                  <input
                    type="text"
                    className="form-control"
                    value={save_data.gstin}
                    required
                    onChange={(e) => {
                      set("gstin", e.target.value, e);
                      SetSaveError(false);
                    }}
                  />

                  {/* {save_error == true ? (
                    <small className="text-red">* Required fields</small>
                  ) : null}
                  {errors.gstin && (
                    <small className="text-red">{errors.gstin}</small>
                  )} */}
                </div>

                <div className="col-md-2 col-4">
                  <label className="form-label d-flex">
                    <input
                      type="checkbox"
                      className="form-check me-2"
                      value={save_data.igst}
                      required
                      onChange={(e) => {
                        SetSaveData((prevValue: any) => {
                          prevValue.igst = !prevValue.igst;
                          return { ...prevValue };
                        });
                        // set("gstin", e.target.value, e);
                        SetSaveError(false);
                      }}
                    />
                    IGST
                  </label>
                </div>

                <div className="col-12">
                  <label className="form-label">Address</label>
                  <textarea
                    className="form-control"
                    rows={2}
                    value={save_data.address}
                    required
                    onChange={(e) => {
                      set("address", e.target.value, e);
                    }}
                  />
                  {/* {errors.address && (
                    <small className="text-red">{errors.address}</small>
                  )} */}
                </div>
              </form>
            </div>
            <div className="row pt-3">
              {/* {Object.keys(service_data).map((key, index) => (
                <div key={index} className="col-lg-6 p-2">
                  {key == "type_1" ? (
                    <h6 className="my-3">Image</h6>
                  ) : key == "type_2" ? (
                    <h6 className="my-3">Video</h6>
                  ) : key == "type_3" ? (
                    <h6 className="my-3">Audio</h6>
                  ) : null}
                  <div>
                    {service_data[key].map((ele, ele_index) => (
                      <div
                        key={ele_index}
                        className="row align-items-center mb-3"
                      >
                        <div className="col-8">
                          <label className="form-check-label">
                            <input
                              className="form-check me-2"
                              type="checkbox"
                              id="flexCheckDefault"
                              checked={ele.checked}
                              onChange={() => {
                                service_on_check(ele, ele_index, key);
                              }}
                            />
                            {ele.name}
                            {ele.quantity_type == "1"
                              ? "-Item Wise"
                              : "-Duration Wise"}
                          </label>
                        </div>
                        {ele.checked ? (
                          <div className="col-4">
                            <input
                              className="form-control"
                              type="number"
                              placeholder="Service price for the company"
                              id="Service_Price"
                              value={ele.price}
                              onChange={(e) => {
                                service_price_on_change(
                                  ele,
                                  ele_index,
                                  key,
                                  e.target.value
                                );
                              }}
                            />
                          </div>
                        ) : null}
                      </div>
                    ))}
                  </div>
                </div>
              ))} */}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light-outline"
              // data-bs-dismiss="modal"
              onClick={() => {
                let item = close_data;
                item.action = "close";
                SetCloseData(item);
                SetSaveData(initial_value);
                myModal.hide();
              }}
            >
              Close
            </button>
            <button
              type="button"
              className="btn btn-light-outline"
              onClick={(event) => {
                save(event);
              }}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
